// extracted by mini-css-extract-plugin
export default {"modalContainer":"MY","fadeIn":"NY","img":"OY","fadeInImg":"PY","greeting":"QY","fadeInGreeting":"RY","imgWrapper":"SY","name":"TY","fadeInName":"UY"};
    if(module.hot) {
      // 1713809679598
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  